<template lang="pug">
    div
        Button(type="primary" size="small" @click="downloadCertData" :disabled="disabled")
            Icon(type="ios-download-outline")

</template>
<script>
import { downloadCert } from "@/api/download";
import JSZip from "jszip";
import { saveAs } from "file-saver";
export default {
    name: "DownloadCertBtn",
    props: {
        data: {},
        fileName: {},
        disabled: { type: Boolean, default: false },
    },
    components: {},
    watch: {},
    created() {},
    data() {
        return {};
    },
    methods: {
        async downloadCertData() {
            const res = await downloadCert(this.data);
            if (res.data.data.length == 0) throw new Error("憑證下載失敗");
            let certData = res.data.data;
            // zip
            const zip = new JSZip();
            certData.forEach((e) => zip.file(e.itemName, e.item));
            const fileContent = await zip.generateAsync({ type: "blob" });
            saveAs(fileContent, this.fileName);
        },
    },
    mounted() {},
    computed: {}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DownloadCertBtn.vue